import {
  ADD_COURIER_COMP_DETAILS,
  FETCH_COURIER_COMP_DETAILS_LIST,
  EDIT_COURIER_COMP_DETAILS,
  UPDATE_COURIER_COMP_DETAILS,
  DELETE_COURIER_COMP_DETAILS,
} from "./_courierCompany_Type";
import { config } from "../../Constants";
import { toast } from "react-toastify";

var REACT_APP_URL = config.url.API_URL;
const axios = require("axios");
const token = localStorage.getItem("jwtToken");

export const createNewDetails = (values, navigate) => {
  return function(dispatch) {
    var OPTIONS = {
      url: REACT_APP_URL + "/api/add-courier-company",
      method: "POST",
      data: values,
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    axios(OPTIONS)
      .then((res) => {
        if (res.status === 201) {
          let result = res.data.data;
          dispatch({
            type: ADD_COURIER_COMP_DETAILS,
            payload: result,
          });
          navigate("../courier_company", { replace: false });
        } else {
          toast("Soming Wrong.....!");
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };
};

export const fetchAllDetails = () => {
  return function(dispatch) {
    var OPTIONS = {
      url: REACT_APP_URL + "/api/get-courier-company",
      method: "GET",
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    axios(OPTIONS)
      .then((res) => {
        if (res.status === 200) {
          let result = res.data.data;
          dispatch({
            type: FETCH_COURIER_COMP_DETAILS_LIST,
            listview: result,
          });
        } else {
          toast("Soming Wrong.....!");
        }
      })
      .catch((err) => {
        dispatch({
          type: FETCH_COURIER_COMP_DETAILS_LIST,
          listview: [],
        });
        toast.error(err.response.data.message);
      });
  };
};

export const editSingleDetails = (id, singleData) => {
  return {
    type: EDIT_COURIER_COMP_DETAILS,
    payload: singleData,
    id: id,
  };
};

export const updateDetails = (updateData, r_id, navigate) => {
  updateData.courierid = r_id;
  return function(dispatch) {
    var OPTIONS = {
      url: REACT_APP_URL + "/api/update-courier-company",
      method: "POST",
      data: updateData,
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    axios(OPTIONS)
      .then((res) => {
        if (res.data.status === 200) {
          let result = res.data.data;

          dispatch({
            type: UPDATE_COURIER_COMP_DETAILS,
            payload: result[0],
          });
          navigate("../courier_company", { replace: false });
        } else {
          toast("Soming Wrong.....!");
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };
};

export const deleteSingleDetails = (id) => {
  return function(dispatch) {
    var OPTIONS = {
      url: REACT_APP_URL + "/api/update-courier-company",
      method: "POST",
      data: { courierid: id, isdelete: true },
      headers: {
        "content-type": "application/json",
        Authorization: "Bearer " + token,
      },
    };

    axios(OPTIONS)
      .then((res) => {
        if (res.data.status === 200) {
          let message = res.data.message;
          dispatch({
            type: DELETE_COURIER_COMP_DETAILS,
            payload: id,
            msg: message,
          });
        } else {
          toast("Soming Wrong.....!");
        }
      })
      .catch((err) => {
        toast.error(err.response.data.message);
      });
  };
};
